console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('window.location.hostname:', window.location.hostname);
console.log('window.location.href:', window.location.href);

// Detekce produkčního prostředí - buď přímo NODE_ENV nebo pokud běží na produkční doméně
const isProduction = process.env.NODE_ENV === 'production' || 
                    window.location.hostname === 'www.crm.vyjedname.cz' ||
                    window.location.hostname === 'crm.vyjedname.cz' ||
                    window.location.hostname === 'crm-frontend-5mj1.onrender.com';

export const API_URL = isProduction
  ? "https://crm-backend-6jqe.onrender.com/api"
  : "http://localhost:5000/api";

console.log('🏭 isProduction:', isProduction);
console.log('🌐 API_URL:', API_URL);
console.log('🔗 Connecting to backend:', API_URL);